import { z } from "zod";

export const LEAD_QUALIFICATIONS = [
  "unassessed",
  "qualified",
  "opportunity",
  "disqualified",
] as const;
export const leadQualificationSchema = z.enum(LEAD_QUALIFICATIONS);
export type LeadQualification = z.infer<typeof leadQualificationSchema>;
export const DISQUALIFICATION_REASONS = [
  "outside_target",
  "not_interested",
  "invalid_contact",
  "other",
] as const;
export const disqualificationReasonSchema = z.enum(DISQUALIFICATION_REASONS);
export type DisqualificationReason = z.infer<typeof disqualificationReasonSchema>;
export const DISQUALIFICATION_REASON_LABELS: Record<DisqualificationReason, string> = {
  outside_target: "Fuori target",
  not_interested: "Non interessato",
  invalid_contact: "Contatto non valido",
  other: "Altro",
};
export const leadConversionInputSchema = z
  .object({
    kind: z.enum(["qualified", "opportunity", "preferred"]),
    version: z.number().int().nonnegative(),
  })
  .strict();
export type LeadConversionInput = z.infer<typeof leadConversionInputSchema>;
export const conversionSuggestionDecisionSchema = z
  .object({
    decision: z.enum(["approve", "dismiss", "later"]),
    version: z.number().int().positive(),
  })
  .strict();
export type ConversionSuggestionDecisionInput = z.infer<typeof conversionSuggestionDecisionSchema>;
export const metaConversionsInputSchema = z
  .object({
    enabled: z.boolean(),
    datasetId: z
      .string()
      .trim()
      .regex(/^\d{5,40}$/)
      .nullable(),
    accessToken: z.string().trim().min(10).max(8192).optional(),
    appSecret: z.string().trim().min(16).max(1024).optional(),
    version: z.number().int().nonnegative(),
  })
  .strict();
export type MetaConversionsInput = z.infer<typeof metaConversionsInputSchema>;
export type MetaConversionsDto = {
  enabled: boolean;
  datasetId: string | null;
  hasCredentials: boolean;
  version: number;
  checkedAt: string | null;
  lastCheckError: string | null;
};
export type MetaConversionEventDto = {
  id: string;
  eventName: string;
  eventTime: string;
  status: "pending" | "processing" | "sent" | "failed" | "skipped";
  sentAt: string | null;
  errorCode: string | null;
  message: string | null;
};
export type ConversionSuggestionDto = {
  id: string;
  kind: "qualified" | "opportunity" | "preferred";
  reason: string;
  version: number;
  status: "pending" | "approved" | "dismissed" | "later";
  createdAt: string;
};
export type LeadConversionsDto = {
  version: number;
  firstResponseAt: string | null;
  qualification: LeadQualification;
  qualifiedAt: string | null;
  opportunityAt: string | null;
  preferredAt: string | null;
  preferredSaleAt: string | null;
  disqualifiedAt: string | null;
  disqualificationReason: DisqualificationReason | null;
  disqualificationNote: string | null;
  canSelectPreferred: boolean;
  metaEnabled: boolean;
  hasMetaLeadId: boolean;
  events: MetaConversionEventDto[];
  suggestions: ConversionSuggestionDto[];
};
export const META_CONVERSION_EVENTS = [
  "Lead",
  "Contact",
  "QualifiedLead",
  "SalesOpportunity",
  "DisqualifiedLead",
  "PreferredCustomer",
] as const;
export const metaConversionEventNameSchema = z.enum(META_CONVERSION_EVENTS);
export type MetaConversionEventName = z.infer<typeof metaConversionEventNameSchema>;
